import {showErrorSnackBar, showInfoSnackBar, showSuccessSnackBar} from "@/utils/SnackBartHelper";
import Utils from "@/scripts/Utils";
import cloneDeep from 'lodash/cloneDeep';
import diff from "deep-diff";
import EnvelopeService from "@/services/server/EnvelopeService";

export default {
    name: 'EnvelopeBasicsTab',
    components: {},
    data: () => ({
        mapperStatus: {
            draft: 'Rascunho',
            canceled: 'Cancelado',
            running: 'Em Progresso',
            closed: 'Finalizado'
        },
        intervalReminder: [
            {text: "Sem Lembrete", value: null},
            {text: "1 Dia", value: "1"},
            {text: "2 Dias", value: "2"},
            {text: "3 Dias", value: "3"},
            {text: "7 Dias", value: "7"},
            {text: "14 Dias", value: "14"},
        ],
        envelopeBasicsData: {},
        initialEnvelopeBasicsData: {},
        isLoadingEnvelopeData: false,
    }),
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        param: {
            type: Object,
            default: () => ({})
        },
        idEnvelope: {
            type: String,
            default: null,
        },
        envelopeStatus: {
            type: String,
            default: null,
        },
    },
    computed: {
        mappedStatus() {
            return this.mapperStatus[this.envelopeBasicsData?.attributes?.status] || 'Desconhecido'
        },
        disabledByStatus() {
            return this.envelopeStatus === 'draft'
        }
    },
    methods: {
        formatDate(date) {
            return Utils.formatDateDayJs(date, 'DD/MM/YYYY [às] HH:mm');
        },
        convertDateString(dateString) {
            const [datePart, timePart] = dateString.split(' às ');

            const [day, month, year] = datePart.split('/');

            return `${year}-${month}-${day}T${timePart}:00.00Z`;
        },
        onInputDate(value) {
            value = value.replace(/[^0-9]/g, "");

            if (value.length <= 2) {
                value = value.replace(/^(\d{0,2})/, "$1");
            } else if (value.length <= 4) {
                value = value.replace(/^(\d{2})(\d{0,2})/, "$1/$2");
            } else if (value.length <= 8) {
                value = value.replace(/^(\d{2})(\d{2})(\d{0,4})/, "$1/$2/$3");
            } else if (value.length <= 10) {
                value = value.replace(/^(\d{2})(\d{2})(\d{4})(\d{0,2})/, "$1/$2/$3 às $4");
            } else {
                value = value.replace(/^(\d{2})(\d{2})(\d{4})(\d{2})(\d{0,2})/, "$1/$2/$3 às $4:$5");
            }

            value = value.replace(/\s+/g, ' ').trim();

            this.envelopeBasicsData.deadline_at = value;
        },
        onKeyPressDate(event) {
            const allowedChars = /[0-9]/;
            if (!allowedChars.test(event.key)) {
                event.preventDefault();
            }
        },
        async saveEnvelopeBasicsData() {
            const diffs = this.getDifferences(this.envelopeBasicsData.attributes, this.initialEnvelopeBasicsData.attributes);

            if (!Object.keys(diffs).length) {
                showInfoSnackBar("Não foram detectadas alterações!");
            } else {
                this.isLoadingEnvelopeData = true;
                if (diffs.hasOwnProperty('deadline_at')) {
                    const formattedDeadline = this.convertDateString(this.envelopeBasicsData?.deadline_at)
                    const inputDate = new Date(formattedDeadline);
                    const currentDate = new Date();

                    if (isNaN(inputDate.getTime()) || inputDate <= currentDate) {
                        showErrorSnackBar("Prazo final deve ser uma data válida e superior ao dia atual!")
                        return;
                    }
                    diffs.deadline_at = formattedDeadline
                }

                try {
                    const result = await EnvelopeService.updateEnvelope(diffs, this.idEnvelope);

                    result.data.data.data.attributes.created = this.formatDate(result.data.data.data.attributes.created)
                    result.data.data.data.attributes.modified = this.formatDate(result.data.data.data.attributes.modified)
                    result.data.data.data.attributes.deadline_at = this.formatDate(result.data.data.data.attributes.deadline_at)

                    this.initialEnvelopeBasicsData = cloneDeep(result.data.data.data)
                    this.envelopeBasicsData = cloneDeep(result.data.data.data)

                    showSuccessSnackBar("Dados do Envelope Atualizados com Sucesso!");
                } catch (e) {
                    this.envelopeBasicsData = cloneDeep(this.initialEnvelopeBasicsData)
                    showErrorSnackBar("Ocoreu um erro inesperado, contacte o suporte!")
                    console.error("Erro em saveEnvelopeBasicData", e)
                }
                this.isLoadingEnvelopeData = false
            }
        },
        getDifferences(obj1, obj2) {
            const differences = {};

            function compareObjects(o1, o2, path = '') {
                for (const key in o1) {
                    const currentPath = path ? `${path}.${key}` : key;

                    if (o2.hasOwnProperty(key)) {
                        if (typeof o1[key] === 'object' && o1[key] !== null && typeof o2[key] === 'object' && o2[key] !== null) {
                            compareObjects(o1[key], o2[key], currentPath);
                        } else if (o1[key] !== o2[key]) {
                            differences[currentPath] = o1[key];
                        }
                    } else {
                        differences[currentPath] = null;
                    }
                }

                for (const key in o2) {
                    const currentPath = path ? `${path}.${key}` : key;
                    if (!o1.hasOwnProperty(key)) {
                        differences[currentPath] = o2[key];
                    }
                }
            }

            compareObjects(obj1, obj2);
            return differences;
        }
    },
    async created() {
    },
    watch: {
        param: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.envelopeBasicsData = cloneDeep(newValue)
                this.initialEnvelopeBasicsData = cloneDeep(newValue)
            }
        },
    }
}